<template>
  <v-dialog
      v-model="show"
      max-width="980"
      scrollable
  >
    <v-card>
      <v-card-title class="text-h5" v-if="definition.id !== 'new'">
        Kataster: "{{definition.name}}" anpassen
      </v-card-title>
      <v-card-title class="text-h5" v-else>
        Neues Kataster anlegen
      </v-card-title>
      <v-card-text>
        <p style="margin-bottom: 6px">Jeder Katastereintag besteht grundsätzlich aus den Feldern: <b>Name</b>, <b>Beschreibung</b> und <b>Dateien</b>.<br>
        Darüber hinaus können Sie im Folgenden weitere Felder und Zwischenüberschriften hinzufügen, sowie die Reihnfolge der Felder anpassen.</p>
        <v-row style="margin-bottom: 8px" v-if="editDefinition.id === 'new' || definition.category !== 'AUGR'">
          <v-col>
            <p class="text-body-1" style="margin-bottom: 0; margin-top: 8px">Katastername:</p>
          </v-col>
          <v-col>
            <v-text-field
                v-model="editDefinition.name"
                :rules="[v => !!v || 'Katastername ist ein Pflichtfeld.']"
                hint="Der Name des Katasters. *Pflichtfeld"
                persistent-hint
                style="padding-top: 0px"
                ref="name"
            ></v-text-field>
          </v-col>
          <v-col v-if="showLegr">
            <p class="text-body-1" style="margin-bottom: 0; margin-top: 8px">Leistungsgruppe:</p>
          </v-col>
          <v-col v-if="showLegr">
            <v-text-field
                v-model="legrName"
                persistent-hint
                style="padding-top: 0px"
                ref="name"
                readonly
                @focus="showLegrDialog"
            ></v-text-field>
          </v-col>
          <v-col v-if="!showLegr" cols="6"></v-col>
        </v-row>
        <v-row style="margin-bottom: 8px">
          <v-col>
            <p class="text-body-1" style="margin-bottom: 0; margin-top: 8px">Katasterdarstellung:</p>
          </v-col>
          <v-col>
            <v-dialog v-model="colorPickerDialog" persistent max-width="600px" scrollable>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :color="editDefinition.color"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    style="width: 100%  "
                >
                  <span v-if="editDefinition.icon !== ''" class="mdi-set v-icon my-icon" style="font-size: 24px; color: black" v-html="`&#x${editDefinition.icon};`"></span>
                  <!--v-icon>mdi-format-color-fill</v-icon-->
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h5">
                  Farbe und Symbol
                </v-card-title>
                <v-card-text style="padding: 0; display: flex">
                  <v-color-picker
                      v-model="editDefinition.color"
                      dot-size="25"
                      hide-inputs
                      hide-alpha
                      show-swatches
                      :swatches="swatches"
                      swatches-max-height="200"
                      style="max-width: 300px"
                  ></v-color-picker>
                  <icon-picker :selected-icon="editDefinition.icon" @input="editDefinition.icon = $event"></icon-picker>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="colorPickerDialog = false; editDefinition.color = color; editDefinition.icon = icon">
                    Abbrechen
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="colorPickerDialog = false; color = editDefinition.color; icon = editDefinition.icon">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-col>
          <v-col cols="6">
            <p v-if="showLegr" style="margin-bottom: 6px">Falls die das Kataster aus bestehenden Leistungen aufbauen wollen, wählen Sie eine Leitungsgruppe aus.</p>
          </v-col>

        </v-row>
        <v-row>
          <v-col>
            <p class="text-h6" style="margin-bottom: 4px; color: rgba(0, 0, 0, 0.87)">
              Mögliche Felder
            </p>
            <p style="margin-bottom: 4px">
                Ziehen Sie ein Feld von hier in die "Vorschau" um es hinzuzufügen.
            </p>
            <v-list dense>
              <draggable
                  v-model="possibleProperties"
                  :group="{ name: 'fields', pull: 'clone', put: false }"
                  item-key="key"
              >
                <div v-for="(field, index) in possibleProperties">
                <v-list-item draggable="true" :key="field.key">
                  <v-combobox v-if="field.property_type === 'auto_complete'"
                      persistent-hint
                      :items="field.auto_complete_options || []"
                      :label="field.name"
                      :hint="field.description"
                              v-model="field.dummy"
                  ></v-combobox>
                  <v-text-field v-else-if="field.property_type === 'string' || field.property_type === 'integer' || field.property_type === 'float'"
                                :label="field.name"
                                :hint="field.description"
                                persistent-hint
                                v-model="field.dummy"
                                :rules="field.property_type === 'float' ? floatRules : (field.property_type === 'integer' ? integerRules : [])"
                  ></v-text-field>
                  <v-menu
                      v-else-if="field.property_type === 'date'"
                      ref="menu"
                      v-model="field.show"
                      :close-on-content-click="false"
                      :return-value.sync="field.dummy"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :value="formatDate(field.dummy)"
                          :label="field.name"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :hint="field.description"
                          persistent-hint
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="field.dummy"
                        no-title
                        scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="field.show = false"
                      >
                        Abbrechen
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.menu[0].save(field.dummy)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-checkbox
                      v-else-if="field.property_type === 'boolean'"
                      :label="field.name"
                      color="primary"
                      :hint="field.description"
                      persistent-hint
                      v-model="field.dummy"
                  ></v-checkbox>
                  <v-select
                      v-else-if="field.property_type === 'select'"
                      :hint="field.description"
                      persistent-hint
                      :items="field.auto_complete_options || []"
                      :label="field.name"
                      v-model="field.dummy"
                  ></v-select>
                  <v-subheader
                      v-else-if="field.property_type === 'sub_header'"
                      style="font-size: 1rem"
                  >
                    {{
                      field.name
                    }}
                  </v-subheader>
                  <v-divider
                      v-if="field.property_type === 'sub_header'"
                  ></v-divider>
                    <v-list-item-action>
                      <v-icon>mdi-drag</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </div>
              </draggable>
            </v-list>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>
                Vorschau
              </v-card-title>
              <v-card-text>
                <v-list dense style="max-height: 60vh; overflow-y: auto">
                  <draggable
                      v-model="editDefinition.properties"
                      group="fields"
                      item-key="key"
                      @add="onAddField"
                  >
                    <div v-for="(field, index) in editDefinition.properties" :key="field.key">
                      <v-list-item>
                        <v-combobox v-if="field.property_type === 'auto_complete'"
                                    persistent-hint
                                    :items="field.auto_complete_options || []"
                                    :label="field.name"
                                    :hint="field.description"
                                    v-model="field.dummy"
                        ></v-combobox>
                        <v-text-field v-else-if="field.property_type === 'string' || field.property_type === 'integer' || field.property_type === 'float'"
                                      :label="field.name"
                                      :hint="field.description"
                                      persistent-hint
                                      v-model="field.dummy"
                                      :rules="field.property_type === 'float' ? floatRules : (field.property_type === 'integer' ? integerRules : [])"
                        ></v-text-field>
                        <v-menu
                            v-else-if="field.property_type === 'date'"
                            :ref="field.key"
                            v-model="field.show"
                            :close-on-content-click="false"
                            :return-value.sync="field.dummy"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formatDate(field.dummy)"
                                :label="field.name"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :hint="field.description"
                                persistent-hint
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="field.dummy"
                              no-title
                              scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="field.show = false"
                            >
                              Abbrechen
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs[field.key][0].save(field.dummy)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-checkbox
                            v-else-if="field.property_type === 'boolean'"
                            :label="field.name"
                            color="primary"
                            :hint="field.description"
                            v-model="field.dummy"
                            persistent-hint
                        ></v-checkbox>
                        <v-select
                            v-else-if="field.property_type === 'select'"
                            :hint="field.description"
                            persistent-hint
                            :items="field.auto_complete_options || []"
                            :label="field.name"
                            v-model="field.dummy"
                        ></v-select>
                        <v-subheader
                            v-else-if="field.property_type === 'sub_header'"
                            style="font-size: 1rem"
                        >
                          {{
                            field.name
                          }}
                        </v-subheader>
                        <v-divider
                            v-if="field.property_type === 'sub_header'"
                        ></v-divider>
                        <v-btn icon small @click="onEdit(index)" style="margin-left: 16px">
                          <v-icon color="green lighten-1">mdi-pencil</v-icon>
                        </v-btn>
                        <v-list-item-action>
                          <v-btn icon small @click="removeField(index)">
                            <v-icon color="red lighten-1">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                  </draggable>
                  <v-list-item v-if="!editDefinition.properties.length" class="text-center">
                    <v-list-item-content>
                      <v-list-item-title class="grey--text">
                        Ziehen Sie ein Feld von der rechten Seite hierher, um es hinzuzufügen.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            v-if="definition.id !== 'new' && definition.category !== 'AUGR'"
            color="warning darken-1"
            text
            @click="showDelete = true;"
        >
          Löschen
        </v-btn>
        <v-btn
            color="success darken-1"
            text
            @click="onSave()"
        >
          {{editDefinition.id === 'new' ? 'Anlegen' : 'Speichern'}}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showEdit"
              max-width="420" scrollable>
      <v-card>
        <v-card-title class="text-h5">
          Feld anpassen
        </v-card-title>
        <v-card-text>
          <v-text-field
                        id="field_name"
                        label="Feldname"
                        hint="Der Name der Feldes, wie er im Kataster angezeigt wird. *Pflichtfeld"
                        persistent-hint
                        v-model="currentProperty.name"
                        :rules="propertyNameRules"
          ></v-text-field>
          <v-text-field
              style="margin-top: 8px"
              id="field_desc"
              label="Feldhinweis"
              hint="Der Hinweis, der unter dem Feld angezeigt wird. Optional."
              persistent-hint
              v-model="currentProperty.description"
          ></v-text-field>
          <v-combobox
              style="margin-top: 8px"
              v-if="currentProperty.property_type === 'auto_complete' || currentProperty.property_type === 'select'"
              v-model="currentProperty.auto_complete_options"
              chips
              :label="(currentProperty.property_type === 'auto_complete' ? 'Autovervollständigungsoptionen' : 'Auswahloptionen')"
              :hint="'Die Texte für die ' + (currentProperty.property_type === 'auto_complete' ? 'Autovervollständigung' : 'Auswahl') + '. Nach einem Eintrag bitte Enter drücken. Entfernen durch Klick auf das Kreuzchen.'"
              persistent-hint
              multiple
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  @click:close="remove(item)"
              >
                <strong>{{ item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="showEdit = false; cancelEdit()"
          >
            Abbrechen
          </v-btn>

          <v-btn
              color="success darken-1"
              text
              @click="saveProperty"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDelete"
              max-width="420">
      <v-card>
        <v-card-title class="text-h5">
          Kataster löschen
        </v-card-title>
        <v-card-text>
          Sie sind dabei, das Kataster <b>"{{editDefinition.name}}"</b> zu löschen. Dies kann nicht rückgängig gemacht werden!<br>
          Sind Sie sicher, dass Sie das Kataster löschen möchten?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="showDelete = false;"
          >
            Abbrechen
          </v-btn>

          <v-btn
              color="error darken-1"
              text
              @click="showDelete = false; show = false; $emit('delete', editDefinition.id)"
          >
            Trozdem löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <select-legr-dialog ref="select_legr_dialog" :legrs="legrs" @select="onLegrChanged"></select-legr-dialog>
  </v-dialog>
</template>

<script>

import draggable from 'vuedraggable';
import IconPicker from '@/views/cadastre/CadastreIconPicker.vue';
import SelectLegrDialog from "@/views/cadastre/SelectLegrDialog.vue";


export default {
  name: "EditCadastreDialog",
  components: {
    draggable,
    IconPicker,
    SelectLegrDialog
  },
  props: {
    definition: {
      type: Object,
      default: () => {
        return {
          id: 'new',
          category: '',
          name: '',
          color: '#2E6F40',
          icon: '',
          description: '',
          properties: [],
          next_property_key: '0',
          properties_order: [],
        }
      }
    },
    legrs: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    editDefinition: {
      id: '',
      category: '',
      name: '',
      color: '',
      icon: '',
      description: '',
      properties: [],
      next_property_key: '',
      properties_order: [],
    },
    show: false,
    showLegr: false,
    legrName: '',
    selectedLegr: null,
    possibleProperties: [
        {
      key: 'string',
      name: 'Textfeld',
      property_type: 'string',
      description: 'Ein Textfeld für kurze Texte',
          dummy: '',
    },
      {
        key: 'integer',
        name: 'Ganzahlenfeld',
        property_type: 'integer',
        description: 'Ein Textfeld für ganze Zahlen',
        dummy: '',
      },
      {
        key: 'float',
        name: 'Dezimalzahlenfeld',
        property_type: 'float',
        description: 'Ein Textfeld für Dezimalzahlen',
        dummy: '',
      },
      {
        key: 'boolean',
        name: 'Ja/Nein-Feld',
        property_type: 'boolean',
        description: 'Ein Feld für Ja/Nein-Werte',
        dummy: false,
      },
      {
        key: 'date',
        name: 'Datumsfeld',
        property_type: 'date',
        description: 'Ein Feld für Datumsangaben',
        dummy: '',
        show: false,
      },
      {
        key: 'auto_complete',
        name: 'Autovervollständigung',
        property_type: 'auto_complete',
        description: 'Ein Feld für Autovervollständigung mit Vorschlägen',
        dummy: '',
        auto_complete_options: [
          'Option 1',
          'Option 2',
          'Option 3',
        ],
      },
      {
        key: 'select',
        name: 'Auswahlfeld',
        property_type: 'select',
        description: 'Ein Feld für die Auswahl aus vordefinierten Optionen',
        dummy: '',
        auto_complete_options: [
          'Option 1',
          'Option 2',
          'Option 3',
        ],
      },
      {
        key: 'sub_header',
        name: 'Zwischenüberschrift',
        property_type: 'sub_header',
        description: 'Eine Zwischenüberschrift für die Gruppierung von Feldern',
      },
    ],
    floatRules: [
      v => {
        if (!v) return true;
        const cleanedValue = v.replace(/\./g, '').replace(',', '.'); // Remove thousands separator, replace comma with dot
        if (isNaN(parseFloat(cleanedValue)) || !isFinite(cleanedValue)) {
          return 'Muss eine gültige Dezimalzahl sein (z.B. 123,45, 1.234,56)';
        }
        return true;
      },
    ],
    integerRules: [
      v => {
        if (!v) return true;
        const cleanedValue = v.replace(/\./g, ''); // Remove thousands separator
        if (!/^-?\d+$/.test(cleanedValue)) { // Regex to check for optional minus and only digits
          return 'Muss eine ganzzahlige Zahl sein (z.B. 123, 1.234)';
        }
        return true;
      },
    ],
    showEdit: false,
    currentProperty:  {
      key: '',
      name: '',
      property_type: '',
      description: '',
      auto_complete_options: [],
    },
    currentPropertyIndex: null,
    currentPropertyNew: false,
    color: '',
    icon: '',
    colorPickerDialog: false,
    propertyNameRules: [
      v => !!v || 'Feldname ist ein Pflichtfeld.',],
    swatches: [
      // Grayscale Palette
      ['#000000', '#616161', '#BDBDBD'],

      // Red & Pink Palette
      ['#B71C1C', '#F44336', '#E91E63'],

      // Orange & Brown Palette
      ['#FF9800', '#FFC107', '#795548'],

      // Green Palette
      ['#2E7D32', '#4CAF50', '#009688'],

      // Blue & Purple Palette
      ['#3F51B5', '#2196F3', '#03A9F4'],
    ],
    showDelete: false,
  }),
  methods: {
    showLegrDialog() {
      this.$refs.select_legr_dialog.open();
      this.$nextTick(() => {
        document.activeElement.blur();
      });
    },
    onLegrChanged(legr) {
      console.log(legr)
      this.selectedLegr = legr;
      if (!legr) {
        this.legrName = '';
      } else {
        this.legrName = legr.name;
      }
    },
    showDialog(showLegr = false) {
      this.showLegr = showLegr;
      this.selectedLegr = null;
      this.show = true;
      console.log(this.definition)
      let def = JSON.parse(JSON.stringify(this.definition));
      if (!def.properties || !def.properties.length) {
        def.properties = [];
        def.properties_order = [];
      }
      for (let i = 0; i < def.properties.length; i++) {
        def.properties[i].dummy = '';
      }
      let orderedProperties = new Array(def.properties_order.length);
      for (let i = 0; i < def.properties_order.length; i++) {
        let key = def.properties_order[i];
        let property = def.properties.find(p => p.key === key);
        if (property) {
          orderedProperties[i] = property;
        }
      }
      def.properties = orderedProperties;
      this.editDefinition = def;
      this.color = this.editDefinition.color;
      this.icon = this.editDefinition.icon;
    },
    removeField(index) {
      this.editDefinition.properties.splice(index, 1);
    },
    remove (item) {
      this.currentProperty.auto_complete_options.splice(this.currentProperty.auto_complete_options.indexOf(item), 1)
    },
    onEdit(index) {
      this.currentPropertyNew= false;
      this.currentProperty = JSON.parse(JSON.stringify(this.editDefinition.properties[index]));
      this.currentPropertyIndex = index;
      this.showEdit = true;
    },
    onAddField(event) {
      const droppedDataType = event.item._underlying_vm_;
      let newField = {
        key: this.editDefinition.next_property_key,
        name: '',
        property_type: droppedDataType.property_type,
        description: '',
        auto_complete_options: [],
        show: false,
        dummy: '',
      };
      this.editDefinition.next_property_key = `${parseInt(this.editDefinition.next_property_key)+1}`;
      this.$nextTick(() => {
        this.$set(this.editDefinition.properties, event.newIndex, newField);
        this.currentPropertyNew = true;
        this.currentProperty = JSON.parse(JSON.stringify(newField));
        this.currentPropertyIndex = event.newIndex;
        this.showEdit = true;
      });
    },
    cancelEdit() {
      if (this.currentPropertyNew) {
        this.editDefinition.properties.splice(this.currentPropertyIndex, 1);
      }
    },
    saveProperty() {
      if (this.currentProperty.name.trim() === '') {
        return;
      }
      this.editDefinition.properties[this.currentPropertyIndex] = JSON.parse(JSON.stringify(this.currentProperty));
      this.showEdit = false;
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    onSave() {
      if (this.editDefinition.name.trim() === '') {
        this.$refs.name.focus();
        return;
      }
      this.editDefinition.properties_order = [];
      for (let i = 0; i < this.editDefinition.properties.length; i++) {
        this.editDefinition.properties_order.push(this.editDefinition.properties[i].key);
      }
      if (this.selectedLegr) {
        this.editDefinition.legr = this.selectedLegr.gischl;
      }
      this.$emit('save', JSON.parse(JSON.stringify(this.editDefinition)));
      this.show = false;
    },
  }
}
</script>

<style scoped>
  ::v-deep .v-input--selection-controls.v-input {
    flex: 1 1 auto;
  }

  ::v-deep .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    margin-top: 2px;
    margin-bottom: 0;
  }

  @font-face {
    font-family: 'MyFont';
    src: url('/fonts/MaterialSymbolsRounded-Medium.ttf') format('truetype');
  }

  .my-icon {
    font-family: 'MyFont' !important;
  }

  .my-filter {
    height: 100%; width: 100%;
  }

  ::v-deep .my-filter>span {
    color: white;
  }

  ::v-deep .my-filter.inactive>span {
    color: rgba(0, 0, 0, 0.87);
  }

  .my-filter:after {
    border-color: rgba(0, 0, 0, 0.42);
    border-style: solid;
    border-width: thin 0 0 0;
    bottom: -1px;
    content: "";
    left: 0;
    position: absolute;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
  }
</style>
